import React from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Button } from '../../../../components/ui/button'
import { Input } from '../../../../components/ui/input'
import { Select } from '../../../../components/ui/select'
import { Path } from '../../../../router/paths'
import { Table } from '../../../../components/ui/table'
import { Icon } from '../../../../components/icons'
import { useFormClients } from '../_hooks'
import { useGlobalContext } from '../../../../context/ContextGlobal'
import { PathDoc } from '../../../../router/docs'

export const ClientsLayout = ({ values, setValues, options, disabledList, type = 'add', clientId }) => {
  const { DeletePlansOfList, statusUserAdmin, AddPlanInList } = useFormClients(values, setValues, options, clientId)

  const { loading } = useGlobalContext()

  return loading ? (
    <>
      <Icon>loading</Icon>
      <p className="has-text-centered has-text-grey-light">Coletando informações, aguarde... </p>
    </>
  ) : (
    <div>
      <Column.Root>
        <Column.Content>
          <Column.Root>
            <Column.Content>
              <Input.Root className="mb-3">
                <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                  CNPJ/CPF
                </Input.Label>
                <Input.Contents>
                  <Input.Prompt
                    className="is-rounded"
                    value={values}
                    setValue={setValues}
                    field={'cpfCnpj'}
                    required={true}
                    disabled={disabledList?.cpfCnpj}
                    maskValue={'cpfCnpj'}
                    maskSetValue={'cpfCnpj'}
                  ></Input.Prompt>
                </Input.Contents>
              </Input.Root>
            </Column.Content>
            {String(values?.cpfCnpj || '').length > 15 && (
              <>
                <Column.Content>
                  <Input.Root className="mb-3">
                    <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      Inscricao Municipal
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        value={values}
                        setValue={setValues}
                        field={'isncMunicipal'}
                        disabled={disabledList?.cpfCnpj}
                        maskValue={'cpfCnpj'}
                        maskSetValue={'cpfCnpj'}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
                <Column.Content>
                  <Input.Root className="mb-3">
                    <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                      Incrição Estadual
                    </Input.Label>
                    <Input.Contents>
                      <Input.Prompt
                        className="is-rounded"
                        value={values}
                        setValue={setValues}
                        field={'isncEstadual'}
                        disabled={disabledList?.cpfCnpj}
                        maskValue={'cpfCnpj'}
                        maskSetValue={'cpfCnpj'}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Input.Root>
                </Column.Content>
              </>
            )}
          </Column.Root>
          {String(values?.cpfCnpj || '').length > 15 && (
            <Column.Root>
              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Tipo de Atividade
                  </Input.Label>
                  <Select.Root>
                    <Select.Content
                      color="is-grey"
                      className="is-fullwidth is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'tipoAtividade'}
                      disabled={disabledList?.uf}
                      required={true}
                    >
                      <Select.Option value={null} title={''} />
                      {(options?.listAtividades || []).map((item) => {
                        return (
                          <Select.Option
                            key={`activate_${item.cCodigo}`}
                            value={item.cCodigo}
                            title={item.cDescricao}
                          />
                        )
                      })}
                    </Select.Content>
                  </Select.Root>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    CNAE
                  </Input.Label>
                  <Select.Root>
                    <Select.Search
                      color="is-grey"
                      className="is-fullwidth is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'cnae'}
                      disabled={disabledList?.cnae}
                      required={true}
                      options={options?.optionsCNAE || []}
                    ></Select.Search>
                  </Select.Root>
                </Input.Root>
              </Column.Content>
            </Column.Root>
          )}
          <Column.Root className="mt-3">
            <Column.Content>
              <Input.Root className="mb-3">
                <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                  Razão Social
                </Input.Label>
                <Input.Contents>
                  <Input.Prompt
                    className="is-rounded"
                    value={values}
                    setValue={setValues}
                    field={'razaoSocial'}
                    required={true}
                    disabled={disabledList?.razaoSocial}
                    maskValue={'title'}
                    maskSetValue={'lower'}
                  ></Input.Prompt>
                </Input.Contents>
              </Input.Root>
            </Column.Content>
            <Column.Content>
              <Input.Root className="mb-3">
                <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                  Nome Fantasia
                </Input.Label>
                <Input.Contents>
                  <Input.Prompt
                    className="is-rounded"
                    value={values}
                    setValue={setValues}
                    field={'nomeFantasia'}
                    required={true}
                    disabled={disabledList?.nomeFantasia}
                    maskValue={'title'}
                    maskSetValue={'lower'}
                  ></Input.Prompt>
                </Input.Contents>
              </Input.Root>
            </Column.Content>
          </Column.Root>

          <p className="ml-3 mb-2 has-text-grey-light subtitle" style={{ marginBottom: 0 }} required={true}>
            Endereço da Empresa
          </p>

          <div className="box mb-6">
            <Column.Root>
              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Cep
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'cep'}
                      required={true}
                      disabled={disabledList?.cep}
                      maskValue={'title'}
                      maskSetValue={'lower'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
                <Input.Error>
                  {values?.cep
                    ? values?.cepError
                      ? values.cepError
                      : ''
                    : 'Digite o cep para preencher automaticamente as informações de endereço'}
                </Input.Error>
              </Column.Content>

              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Endereço
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'endereco'}
                      required={true}
                      disabled={disabledList?.endereco}
                      maskValue={'title'}
                      maskSetValue={'lower'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content size="is-2">
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Número
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'endereco_numero'}
                      required={true}
                      disabled={disabledList?.endereco_numero}
                    ></Input.Prompt>
                  </Input.Contents>
                  <Input.Error>{values?.cep && !values?.endereco_numero ? 'Campo obrigatório' : ''}</Input.Error>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                    Complemento
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'complemento'}
                      disabled={disabledList?.complemento}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>

            <Column.Root>
              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Bairro
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'bairro'}
                      required={true}
                      disabled={disabledList?.logradouro}
                      maskValue={'title'}
                      maskSetValue={'lower'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>

              <Column.Content>
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Municipio
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'municipio'}
                      required={true}
                      disabled={disabledList?.logradouro}
                      maskValue={'title'}
                      maskSetValue={'lower'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>

              <Column.Content size="is-2">
                <Input.Root className="">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    UF
                  </Input.Label>
                  {values?.manualCompleted ? (
                    <Select.Root>
                      <Select.Content
                        color="is-grey"
                        className="is-fullwidth is-rounded"
                        value={values}
                        setValue={setValues}
                        field={'uf'}
                        disabled={disabledList?.uf}
                        required={true}
                      >
                        <Select.Option value={null} title={''} />
                        <Select.Option value={'AC'} title={'AC'} />
                        <Select.Option value={'AL'} title={'AL'} />
                        <Select.Option value={'AP'} title={'AP'} />
                        <Select.Option value={'AM'} title={'AM'} />
                        <Select.Option value={'BA'} title={'BA'} />
                        <Select.Option value={'CE'} title={'CE'} />
                        <Select.Option value={'DF'} title={'DF'} />
                        <Select.Option value={'ES'} title={'ES'} />
                        <Select.Option value={'GO'} title={'GO'} />
                        <Select.Option value={'MA'} title={'MA'} />
                        <Select.Option value={'MT'} title={'MT'} />
                        <Select.Option value={'MS'} title={'MS'} />
                        <Select.Option value={'MG'} title={'MG'} />
                        <Select.Option value={'PA'} title={'PA'} />
                        <Select.Option value={'PB'} title={'PB'} />
                        <Select.Option value={'PR'} title={'PR'} />
                        <Select.Option value={'PE'} title={'PE'} />
                        <Select.Option value={'PI'} title={'PI'} />
                        <Select.Option value={'RJ'} title={'RJ'} />
                        <Select.Option value={'RN'} title={'RN'} />
                        <Select.Option value={'RS'} title={'RS'} />
                        <Select.Option value={'RO'} title={'RO'} />
                        <Select.Option value={'RR'} title={'RR'} />
                        <Select.Option value={'SC'} title={'SC'} />
                        <Select.Option value={'SP'} title={'SP'} />
                        <Select.Option value={'SE'} title={'SE'} />
                        <Select.Option value={'TO'} title={'TO'} />
                      </Select.Content>
                    </Select.Root>
                  ) : (
                    <Input.ReadOnly className="is-rounded">{values.uf}</Input.ReadOnly>
                  )}
                </Input.Root>
              </Column.Content>
            </Column.Root>
          </div>
          <p className="ml-3 mb-2 has-text-grey-light subtitle" style={{ marginBottom: 0 }} required={true}>
            Informações do Responsavel
          </p>

          <div className="box mb-6">
            <Input.Root className="mb-3">
              <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                Nome do Responsavel
              </Input.Label>
              <Input.Contents>
                <Input.Prompt
                  className="is-rounded"
                  value={values}
                  setValue={setValues}
                  field={'reponsavel_name'}
                  required={true}
                  disabled={disabledList?.descricao}
                  maskValue={'title'}
                  maskSetValue={'title'}
                ></Input.Prompt>
              </Input.Contents>
            </Input.Root>

            <Column.Root>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    CPF do Responsável
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'responsavel_cpf'}
                      required={true}
                      disabled={disabledList?.descricao}
                      maskSetValue={'cpf'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Telefone do Responsável
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'responsavel_telefone'}
                      required={true}
                      disabled={disabledList?.descricao}
                      maskSetValue={'tel'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content size="">
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    E-mail do Responsável
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      type="email"
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'responsavel_email'}
                      required={true}
                      disabled={disabledList?.descricao}
                    ></Input.Prompt>
                    <p className="has-text-danger ml-3">{statusUserAdmin}</p>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>
          </div>

          <p className="ml-3 mb-2 has-text-grey-light subtitle" style={{ marginBottom: 0 }} required={true}>
            Dados Bancários
          </p>

          <div className="box mb-6">
            <Column.Root>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Banco
                  </Input.Label>
                  <Select.Root>
                    <Select.Search
                      color="is-grey"
                      className="is-fullwidth is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_banco'}
                      disabled={disabledList?.uf}
                      required={true}
                      options={options?.optionsBanks || []}
                    ></Select.Search>
                  </Select.Root>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Agência
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_agencia'}
                      required={true}
                      disabled={disabledList?.descricao}
                      maskSetValue={'tel'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content size="">
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Conta
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_conta'}
                      required={true}
                      disabled={disabledList?.descricao}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>
            <Column.Root>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Titular da Conta
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_name_titular'}
                      required={true}
                      disabled={disabledList?.descricao}
                      maskSetValue={'lower'}
                      maskValue={'title'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    CNPJ/CPF do Titular
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_cpf_titular'}
                      required={true}
                      disabled={disabledList?.descricao}
                      maskValue={'cpfCnpj'}
                      maskSetValue={'cpfCnpj'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content size="">
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    PIX
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'infoBanks_pix'}
                      required={true}
                      disabled={disabledList?.descricao}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
            </Column.Root>
          </div>

          <p className="ml-3 mb-2 has-text-grey-light subtitle" style={{ marginBottom: 0 }} required={true}>
            Cobrança
          </p>

          <div className="box mb-6">
            <Column.Root>
              <Column.Content size="">
                <Input.Root className="mb-3">
                  <Input.Label
                    className="ml-3 has-text-grey"
                    style={{ marginBottom: 0 }}
                    required={!disabledList?.dtStartContract}
                  >
                    Inicio do Contrato
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'dtStartContract'}
                      required={!disabledList?.dtStartContract}
                      disabled={disabledList?.dtStartContract}
                      type={'date'}
                    ></Input.Prompt>
                    {disabledList?.dtStartContract && (
                      <Input.Error>Campo somente prenchido na criação do cliente</Input.Error>
                    )}
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label
                    className="ml-3 has-text-grey"
                    style={{ marginBottom: 0 }}
                    required={!disabledList?.freeTrial}
                  >
                    Período de Teste
                  </Input.Label>
                  <Select.Root>
                    <Select.Content
                      color="is-grey"
                      className="is-fullwidth is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'freeTrial'}
                      disabled={disabledList?.freeTrial}
                    >
                      <Select.Option value="null" title="" />
                      <Select.Option value="00" title="Sem Período de Teste" />
                      <Select.Option value="01" title="01 Dia" />
                      <Select.Option value="03" title="03 Dias" />
                      <Select.Option value="05" title="05 Dias" />
                      <Select.Option value="07" title="07 Dias" />
                      <Select.Option value="10" title="10 Dias" />
                      <Select.Option value="15" title="15 Dias" />
                      <Select.Option value="20" title="20 Dias" />
                      <Select.Option value="25" title="25 Dias" />
                      <Select.Option value="30" title="30 Dias" />
                      <Select.Option value="60" title="2 meses" />
                      <Select.Option value="90" title="3 meses" />
                      <Select.Option value="120" title="4 meses" />
                      <Select.Option value="150" title="5 meses" />
                      <Select.Option value="180" title="6 meses" />
                      <Select.Option value="210" title="7 meses" />
                      <Select.Option value="240" title="8 meses" />
                      <Select.Option value="270" title="9 meses" />
                      <Select.Option value="300" title="10 meses" />
                      <Select.Option value="330" title="11 meses" />
                      <Select.Option value="365" title="Anual" />
                    </Select.Content>
                  </Select.Root>
                </Input.Root>
              </Column.Content>
              <Column.Content size="">
                <Input.Root className="mb-3">
                  <Input.Label
                    className="ml-3 has-text-grey"
                    style={{ marginBottom: 0 }}
                    required={!disabledList?.firstPayment}
                  >
                    Primeira Cobrança
                  </Input.Label>
                  <Input.Contents>
                    <Input.Prompt
                      className="is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'firstPayment'}
                      required={!disabledList?.firstPayment}
                      disabled={disabledList?.firstPayment}
                      type={'date'}
                    ></Input.Prompt>
                  </Input.Contents>
                </Input.Root>
              </Column.Content>
              <Column.Content>
                <Input.Root className="mb-3">
                  <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required={true}>
                    Tipo de Pagamento
                  </Input.Label>
                  <Select.Root>
                    <Select.Content
                      color="is-grey"
                      className="is-fullwidth is-rounded"
                      value={values}
                      setValue={setValues}
                      field={'type_invoices'}
                      disabled={disabledList?.type}
                    >
                      <Select.Option value="null" title="" />
                      <Select.Option value="boleto" title="Pagamento via Boleto" />
                      <Select.Option value="pix" title="Pagamento via Pix" />
                    </Select.Content>
                  </Select.Root>
                </Input.Root>
              </Column.Content>
            </Column.Root>
            <div className="table-container">
              <Table.Root className="is-fullwidth has-text-centered mb-5 mt-2">
                <Table.Head>
                  <Table.Row>
                    <Table.Cell size={10}>Nº</Table.Cell>
                    <Table.Cell>Período de cobrança</Table.Cell>
                    <Table.Cell>Valor da cobrança</Table.Cell>
                    <Table.Cell>Staff Gratuito</Table.Cell>
                    <Table.Cell>Valor por staff</Table.Cell>
                    <Table.Cell>Data de vigência</Table.Cell>
                    <Table.Cell size={80}>Ações</Table.Cell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(values?.plans || []).map((plan) => {
                    return (
                      <Table.Row key={`planslist_${plan?.index}`}>
                        {/* index */}
                        <Table.Cell className="is-vcentered">{plan?.index}</Table.Cell>
                        {/* Período de cobrança */}
                        <Table.Cell className="is-vcentered">
                          <Select.Root>
                            <Select.Content
                              color="is-grey"
                              className="is-fullwidth is-rounded"
                              value={plan.billing}
                              setValue={(v) => {
                                return setValues((prev) => {
                                  const newPlan = { ...plan, billing: v }
                                  return {
                                    ...prev,
                                    plans: [
                                      ...(prev.plans || []).map((item) => {
                                        if (item.index !== plan.index) {
                                          return item
                                        }
                                        return newPlan
                                      }),
                                    ],
                                  }
                                })
                              }}
                            >
                              <Select.Option value="null" title="" />
                              <Select.Option value="07" title="7 Dias" />
                              <Select.Option value="15" title="15 Dias" />
                              <Select.Option value="30" title="30 Dias" />
                              <Select.Option value="60" title="2 meses" />
                              <Select.Option value="90" title="3 meses" />
                              <Select.Option value="120" title="4 meses" />
                              <Select.Option value="150" title="5 meses" />
                              <Select.Option value="180" title="6 meses" />
                              <Select.Option value="210" title="7 meses" />
                              <Select.Option value="240" title="8 meses" />
                              <Select.Option value="270" title="9 meses" />
                              <Select.Option value="300" title="10 meses" />
                              <Select.Option value="330" title="11 meses" />
                              <Select.Option value="365" title="Anual" />
                            </Select.Content>
                          </Select.Root>
                        </Table.Cell>
                        {/* Valor da cobrança */}
                        <Table.Cell className="is-vcentered">
                          <Input.Root>
                            <Input.Contents alignIcon="left">
                              <Input.Prompt
                                type="numeric"
                                maskSetValue="money"
                                maskValue="money"
                                className="is-rounded"
                                value={plan.value}
                                setValue={(v) => {
                                  return setValues((prev) => {
                                    const newPlan = { ...plan, value: v }
                                    return {
                                      ...prev,
                                      plans: [
                                        ...(prev.plans || []).map((item) => {
                                          if (item.index !== plan.index) {
                                            return item
                                          }
                                          return newPlan
                                        }),
                                      ],
                                    }
                                  })
                                }}
                                required={(values?.plans || []).length > 1 && plan.index !== values.plans.length - 1}
                              ></Input.Prompt>
                              <Input.Icon align="is-left">R$</Input.Icon>
                            </Input.Contents>
                          </Input.Root>
                        </Table.Cell>
                        {/* Staff gratuito */}
                        <Table.Cell className="is-vcentered">
                          <Input.Root>
                            <Input.Contents alignIcon="left">
                              <Input.Prompt
                                type="numeric"
                                className="is-rounded"
                                value={plan.staffLimit}
                                setValue={(v) => {
                                  return setValues((prev) => {
                                    const newPlan = { ...plan, staffLimit: v }
                                    return {
                                      ...prev,
                                      plans: [
                                        ...(prev.plans || []).map((item) => {
                                          if (item.index !== plan.index) {
                                            return item
                                          }
                                          return newPlan
                                        }),
                                      ],
                                    }
                                  })
                                }}
                                required={(values?.plans || []).length > 1 && plan.index !== values.plans.length - 1}
                              ></Input.Prompt>
                              <Input.Icon align="is-left">
                                <Icon size={16}>user</Icon>
                              </Input.Icon>
                            </Input.Contents>
                          </Input.Root>
                        </Table.Cell>
                        {/* Valor por staff */}
                        <Table.Cell className="is-vcentered">
                          <Input.Root>
                            <Input.Contents alignIcon="left">
                              <Input.Prompt
                                type="numeric"
                                maskSetValue="money"
                                maskValue="money"
                                className="is-rounded is-fullwidth"
                                value={plan.valuePerStaff}
                                setValue={(value) => {
                                  return setValues((prev) => {
                                    const newPlan = { ...plan, valuePerStaff: value }
                                    return {
                                      ...prev,
                                      plans: [
                                        ...(prev.plans || []).map((item) => {
                                          if (item.index !== plan.index) {
                                            return item
                                          }
                                          return newPlan
                                        }),
                                      ],
                                    }
                                  })
                                }}
                                required={(values?.plans || []).length > 1 && plan.index !== values.plans.length - 1}
                              ></Input.Prompt>
                              <Input.Icon align="is-left">R$</Input.Icon>
                            </Input.Contents>
                          </Input.Root>
                        </Table.Cell>
                        {/* Data de vigência */}
                        <Table.Cell className="is-vcentered">
                          <Input.Prompt
                            type="date"
                            className="is-rounded mt-4"
                            color={
                              (values?.plans || []).length > 1 && plan.index !== values.plans.length - 1 && !plan?.dtEnd
                                ? 'is-danger'
                                : 'is_light'
                            }
                            value={plan.dtEnd}
                            setValue={(value) => {
                              return setValues((prev) => {
                                const newPlan = { ...plan, dtEnd: value }
                                return {
                                  ...prev,
                                  plans: [
                                    ...(prev.plans || []).map((item) => {
                                      if (item.index !== plan.index) {
                                        return item
                                      }
                                      return newPlan
                                    }),
                                  ],
                                }
                              })
                            }}
                            required={(values?.plans || []).length > 1 && plan.index !== values.plans.length - 1}
                            disabled={disabledList?.dtEndPlan}
                          ></Input.Prompt>

                          {!plan?.dtEndPlan && (
                            <p className="is-size-7 has-text-danger">
                              {(values?.plans || []).length > 1 &&
                              plan.index !== values.plans.length - 1 &&
                              !plan?.dtEnd
                                ? 'Adicione uma data de término'
                                : '(Vitalício)'}
                            </p>
                          )}
                        </Table.Cell>
                        {/* Ações */}
                        <Table.Cell className="is-vcentered">
                          <Button.Root>
                            <Button.Content>
                              <Button.Bt
                                className=""
                                color="is-danger"
                                size={'is-small'}
                                colorText="has-text-white"
                                action={() => {
                                  DeletePlansOfList(plan?.index)
                                }}
                                loading={loading}
                              >
                                <Icon size={15}>trash</Icon>
                              </Button.Bt>
                            </Button.Content>
                          </Button.Root>
                        </Table.Cell>
                      </Table.Row>
                    )
                  })}
                </Table.Body>
              </Table.Root>
            </div>
            <Column.Root>
              <Column.Content>
                <Button.Root align="right mr-4">
                  <Button.Content>
                    <Button.Bt
                      className=""
                      color="is-success"
                      colorText="has-text-white"
                      loading={loading}
                      action={AddPlanInList}
                    >
                      +
                    </Button.Bt>
                  </Button.Content>
                </Button.Root>
              </Column.Content>
            </Column.Root>
          </div>
        </Column.Content>
      </Column.Root>
      <Column.Root className="mt-5 mb-6">
        <Column.Content>
          <Button.Root align="right">
            <Button.Content>
              <Button.A className={'mr-4'} link={PathDoc.CreateUser} openNew color="is-light" loading={loading}>
                Tutorial
              </Button.A>
              <Button.A color="is-light" link={Path.AClients} loading={loading}>
                {type === 'edit' ? 'Voltar' : 'Cancelar'}
              </Button.A>
            </Button.Content>
            <Button.Content>
              <Button.Bt className="" color="is-success" colorText="has-text-white" type={'submit'} loading={loading}>
                Salvar
              </Button.Bt>
            </Button.Content>
          </Button.Root>
        </Column.Content>
      </Column.Root>
    </div>
  )
}
